import request from '../../../helpers/request';

const addFlatMeter = async (values) => {
  const response = await request.post(
    `/Meter/individual_meter`,
    values,
    `При добавлении счетчика произошла ошибка`,
    'Error'
  );

  return response;
};

export default addFlatMeter;
